import { ArrowRight } from "lucide-react";

export function FlowDiagram({ steps }: { steps: string[] }) {
  return (
    <div className="flex flex-col items-center gap-3 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-2">
      {steps.map((label, i) => (
        <div key={label} className="flex items-center gap-2">
          <div className="glass-panel rounded-card px-5 py-3.5">
            <span className="text-xs font-medium text-text-secondary sm:text-sm">{label}</span>
          </div>
          {i < steps.length - 1 && (
            <ArrowRight className="hidden h-4 w-4 flex-shrink-0 text-text-muted sm:block" />
          )}
        </div>
      ))}
    </div>
  );
}
